<template>
  <v-card class="mx-auto" outlined @click="onClick()" style="border-style: none" :disabled="disabled">
    <v-list-item class="pl-0" style="height: 35px; min-height: 35px">
      <v-list-item-icon v-if="icon" class="mt-1 mr-0">
        <v-icon size="30" :color="color">{{ icon }}</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title class="text-decoration-underline">
          <span :style="{ fontSize: fontSize }" style="color: var(--v-primary-base)">{{ label }}</span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'BtnLink',

  props: {
    label: {
      type: [String, Number],
      required: true,
    },
    icon: {
      type: String,
      reuqired: false,
      default: '',
    },
    color: {
      type: String,
      required: false,
      default: 'primary',
    },
    fontSize: {
      type: String,
      required: false,
      default: '14px',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>

<style>
.item {
  font-size: v-bind(fontSize);
}
</style>
